var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolidFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.75L10.225 14.4917C9.75833 14.9583 9.5 15.5667 9.5 16.2167C9.5 17.5667 10.625 18.6667 12 18.6667C13.375 18.6667 14.5 17.5667 14.5 16.2167C14.5 15.5667 14.2417 14.95 13.775 14.4917L12 12.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 6.99996L14.9666 7.45829C13.9833 8.68329 12 7.99163 12 6.41663V3.66663C12 3.66663 5.33331 6.99996 5.33331 12.8333C5.33331 15.2666 6.63331 17.3916 8.57498 18.55C8.10831 17.8916 7.83331 17.0833 7.83331 16.2166C7.83331 15.1166 8.26665 14.0833 9.05831 13.3L12 10.4166L14.9416 13.3083C15.7333 14.0833 16.1666 15.1166 16.1666 16.225C16.1666 17.075 15.9083 17.8583 15.4583 18.5166C17.0333 17.5583 18.2 15.9666 18.55 14.1C19.1 11.1416 17.6583 8.34996 15.3333 6.99996Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidFire);
export default __webpack_public_path__ + "static/media/solid-fire.0702fd35ac281d2823f61732daf63b4c.svg";
export { ForwardRef as ReactComponent };